import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  sendUserAnswersAction,
  setAnswersAction,
} from 'root-redux/actions/user'
import { selectUUID } from 'root-redux/selects/user'

import { TechnicalIssuesOptionValue } from 'modules/unsubscribe/pages/TechnicalIssues/constants'

import { Events, eventLogger } from 'services/eventLogger.service'

import { PageId } from 'page-constants'
import { Language } from 'root-constants'

import { FemiButton } from '../../components/FemiButton'
import { FemiFeedbackPopup } from '../../components/FemiFeedbackPopup'
import { FemiOption } from '../../components/FemiOption'
import { FemiPageContainer } from '../../components/FemiPageContainer'
import { useCancelSubscription } from '../../hooks/useCancelSubscription'
import { FemiContent, FemiOptions } from '../../styles'
import { StyledFemiTechnicalIssues as S } from './FemiTechnicalIssues.styles'
import { FEMI_TECHNICAL_ISSUES_VALUES } from './constants'

export const FemiTechnicalIssues: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const userId = useSelector(selectUUID)
  const {
    isFeedbackPopupShown,
    askFeedback,
    closeFeedbackPopup,
    cancelSubscription,
  } = useCancelSubscription()

  const [answers, setAnswers] = useState<TechnicalIssuesOptionValue[]>([])

  const handleContinue = () => {
    dispatch(setAnswersAction({ answers, pageId: PageId.TECHNICAL_ISSUES }))
    dispatch(sendUserAnswersAction())

    eventLogger.logQuestion({
      event: Events.UNSUB_FLOW_QUESTION_3_END,
      question: t('retention.technicalIssues.title', { lng: Language.EN }),
      answers,
      userId,
    })

    askFeedback()
  }

  const toggleAnswer = (value: TechnicalIssuesOptionValue) => {
    setAnswers((currentAnswers) =>
      currentAnswers.includes(value)
        ? currentAnswers.filter((item) => item !== value)
        : [...currentAnswers, value],
    )
  }

  return (
    <FemiPageContainer hasNavigation>
      <S.Content>
        <FemiContent>
          <S.Title>{t('retention.technicalIssues.title')}</S.Title>
          <FemiOptions>
            {FEMI_TECHNICAL_ISSUES_VALUES.map((value) => (
              <FemiOption
                key={value}
                hasCheckbox
                isSelected={answers.includes(value)}
                onClick={() => toggleAnswer(value)}
              >
                {t(`retention.femi.technicalIssues.answers.${value}`)}
              </FemiOption>
            ))}
          </FemiOptions>
        </FemiContent>
      </S.Content>
      <S.BottomArea isFixed>
        <FemiButton
          type="button"
          disabled={!answers.length}
          onClick={handleContinue}
        >
          {t('button.continue')}
        </FemiButton>
        <FemiButton type="button" variant="transparent" onClick={askFeedback}>
          {t('retention.femi.skip')}
        </FemiButton>
      </S.BottomArea>
      <FemiFeedbackPopup
        isShown={isFeedbackPopupShown}
        onComplete={cancelSubscription}
        onClose={closeFeedbackPopup}
      />
    </FemiPageContainer>
  )
}
